import { render, staticRenderFns } from "./AccountSettingProfile.vue?vue&type=template&id=322de8b1&"
import script from "./AccountSettingProfile.vue?vue&type=script&lang=js&"
export * from "./AccountSettingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports